import React from 'react';

import banner from '../../static/images/woolcross/banner.jpg';
import bannerMobile from '../../static/images/woolcross/banner-bg.jpg';
import banner_shoe from '../../static/images/woolcross/banner-shoe.png';


import red1 from '../../static/images/woolcross/red1.png';
import red2 from '../../static/images/woolcross/red2.png';
import gray1 from '../../static/images/woolcross/gray1.png';
import gray2 from '../../static/images/woolcross/gray2.png';
import black1 from '../../static/images/woolcross/black1.png';
import black2 from '../../static/images/woolcross/black2.png';
import black1_v2 from '../../static/images/woolcross/black1_v2.png';
import black2_v2 from '../../static/images/woolcross/black2_v2.png';
import green1 from '../../static/images/woolcross/green1.png';
import green2 from '../../static/images/woolcross/green2.png';
import blue_grren1 from '../../static/images/woolcross/blue_grren1.png';
import blue_grren2 from '../../static/images/woolcross/blue_grren2.png';
import blue1 from '../../static/images/woolcross/blue1.png';
import blue2 from '../../static/images/woolcross/blue2.png';
import pink1 from '../../static/images/woolcross/pink1.png';
import pink2 from '../../static/images/woolcross/pink2.png';

import staticBgSec3 from '../../static/images/woolcross/sec3-bg.jpg';
import staticBgSec3Mobile from '../../static/images/woolcross/sec3-bg-sm.jpg';

import staticBgSec4 from '../../static/images/woolcross/sec4-bg.jpg';

import staticBgSec5 from '../../static/images/woolcross/sec5-bg.jpg';
import staticShoeLayer1 from './../../static/images/woolcross/shoe-layers-1.png';
import staticShoeLayer2 from './../../static/images/woolcross/shoe-layers-2.png';
import staticShoeLayer3 from './../../static/images/woolcross/shoe-layers-3.png';
import staticShoeLayer4 from './../../static/images/woolcross/shoe-layers-4.png';


import staticBgSec6 from '../../static/images/woolcross/sec6-bg.jpg';
import staticBgSec6Mobile from '../../static/images/woolcross/sec6-bg-sm.jpg';

import staticBgSec7 from '../../static/images/woolcross/sec7-bg.jpg';
import staticBgSec7Mobile from '../../static/images/woolcross/sec7-sm-bg.jpg';

import staticBgSec8 from '../../static/images/woolcross/sec8-bg.jpg';
import staticBgSec8Mobile from '../../static/images/woolcross/sec8-bg-sm.jpg';

import staticBgSec9 from '../../static/images/woolcross/sec9-bg.jpg';
import staticGrip from '../../static/images/woolcross/grip.png';



const WoolCross1 = (props) => {
    const {
        bannerText,
        bannerQualityText,
        bannerImage,
        bannerImageMobile,
        bannerShoeLayer,
        bannerPrice,
        bannerButton1Text,
        bannerButton2Text,
        bannerButton1Url,
        bannerButton2Url,

        bgSec3,
        bgSec3Mobile,
        sec3Text,

        bgSec4,
        sec4Text,
        sec4Button1Text,
        sec4Button1Url,
        sec4Button2Text,
        sec4Button2Url,

        bgSec5,
        sec5Text,

        bgSec6,
        bgSec6Mobile,
        sec6Text,

        bgSec7,
        bgSec7Mobile,
        sec7Text,

        bgSec8,
        bgSec8Mobile,
        sec8Text,
        sec8Button1Text,
        sec8Button1Url,
        sec8Button2Text,
        sec8Button2Url,

        bgSec9,
        sec9Text,
    } = props;

    return (
        <div className="landingpage-woolcross">
             <style>
            {`
                .banner {
                background: #cbd3d6 url(${bannerImageMobile}) no-repeat 50% 100%;
                }

                @media (min-width: 768px) {
                    .banner{
                        background-image:url(${bannerImage});
                    }
                }
            `}
            </style>
            <section className="banner text-md-right">
                <div className="container">
                <article className="content clearfix">
                    {bannerText}
                    <p className="quality">{bannerQualityText}</p>
                </article>
                <img src={bannerShoeLayer} alt="MERINO WOOL CROSS X - 100% MERINO WOOL" className="banner-shoe d-md-none" />
                </div>
                <div className="cta">
                <div className="container px-0 px-md-3">
                    <p className="d-none d-md-block h2 price pb-3">{bannerPrice}</p>
                    <div className="row compact btn-cont float-md-right">
                    <div className="col-6"><a href={bannerButton1Url} className="btn btn-dark btn-block mb-3">{bannerButton1Text}</a></div>
                    <div className="col-6"><a href={bannerButton2Url} className="btn btn-dark  btn-block mb-3">{bannerButton2Text}</a></div>
                    </div>
                </div>
                </div>
            </section>
            <section className="sec2 py-0 featured text-center d-none d-xl-block">
            <div className="container-fluid">
                <div className="row">
                <figure className="col-12 col-xl shoe"><p className="bg-light"><img src={red1} alt="" className="shoe-1" /><img src={red2} alt="" className="shoe-2" /></p></figure>
                <figure className="col-12 col-xl shoe"><p className="bg-light"><img src={gray1} alt="" className="shoe-1" /><img src={gray2} alt="" className="shoe-2" /></p></figure>
                <figure className="col-12 col-xl shoe"><p className="bg-light"><img src={black1} alt="" className="shoe-1" /><img src={black2} alt="" className="shoe-2" /></p></figure>
                <figure className="col-12 col-xl shoe"><p className="bg-light"><img src={black1_v2} alt="" className="shoe-1" /><img src={black2_v2} alt="" className="shoe-2" /></p></figure>
                <figure className="col-12 col-xl shoe"><p className="bg-light"><img src={green1} alt="" className="shoe-1" /><img src={green2} alt="" className="shoe-2" /></p></figure>
                <figure className="col-12 col-xl shoe"><p className="bg-light"><img src={blue_grren1} alt="" className="shoe-1" /><img src={blue_grren2} alt="" className="shoe-2" /></p></figure>
                <figure className="col-12 col-xl shoe"><p className="bg-light"><img src={blue1} alt="" className="shoe-1" /><img src={blue2} alt="" className="shoe-2" /></p></figure>
                <figure className="col-12 col-xl shoe"><p className="bg-light"><img src={pink1} alt="" className="shoe-1" /><img src={pink2} alt="" className="shoe-2" /></p></figure>       
                </div>
            </div>
            </section>

            <style>
                {`
                .sec3 {
                    background:url(${bgSec3Mobile});
                }

                @media (min-width: 768px) {
                    .sec3 {
                    background-image: url(${bgSec3});
                    }
                }
                `}
            </style>

            <section className="sec sec3 d-flex ">
                <div className="container d-flex flex-grow-1">
                    <div className="row flex-grow-1">
                    <article className="content col-10 col-sm-8 col-md-8 col-lg-7 col-xl-6 mr-auto align-self-center">
                        {sec3Text}
                    </article>
                    </div>
                </div>
            </section>


            <style>
            {`

            .sec4 {
                background:url(${bgSec4});
            }

            @media (min-width: 768px){
                .sec4 {
                    background-image: url(${bgSec4});
                }
            }

            `}
            </style>

            <section className="sec sec4 d-flex">
                <div className="container d-flex flex-grow-1">
                    <div className="row flex-grow-1">
                    <article className="content col-9 col-sm-7 col-md-6 col-lg-6 col-xl-5 ml-auto align-self-center  pt-lg-5 mt-xl-5 pr-xl-5">
                        {sec4Text}
                        <p className="mt-lg-5 pt-xl-4 d-flex mb-0 text-center">
                            <a href={sec4Button1Url} className="btn btn-outline-light mb-1 mr-2">{sec4Button1Text}</a> <a href={sec4Button2Url} className="btn btn-outline-light mb-1 ml-2">{sec4Button2Text}</a>
                        </p>
                    </article>
                    </div>
                </div>
            </section>

            <style>
            {`

            .sec5 {
                background:url(${bgSec5});
            }

            @media (min-width: 768px){
                .sec5 {
                    background-image: url(${bgSec5});
                }
            }

            `}
            </style>

            <section className="sec sec5">
            <div className="container">
                <div className="row">
                <article className="content col-12 col-sm-11 col-md-5 col-lg-7 col-xl-6 mr-auto align-self-center ">
                    {sec5Text}
                </article>
                <figure className="figure col-12 col-sm-12 col-md-7 col-lg-5 col-xl-6 ml-auto align-self-center">
                    {/*  <img src="images/shoe-layers.png" alt="" />*/}
                    <div id="slipper-animation">
                    <div id="animationWrapper" className="clearfix">
                        <div id="slipper-animation-container" className="float-lg-right">
                        <figure id="AnimationContainer" className="animation-container">
                            <picture id="layer-top">
                            <source srcSet={staticShoeLayer1} />
                            <img src={staticShoeLayer1} alt="" id="layer-top-img" />
                            </picture>									
                            <picture id="layer-inside" style={{transform: 'translateY(0px)'}}>
                            <source srcSet={staticShoeLayer2} />
                            <img src={staticShoeLayer2} alt="" id="layer-inside-img" />
                            </picture>
                            <picture id="layer-bottom" style={{transform: 'translateY(0px)'}}>
                            <source srcSet={staticShoeLayer3} />
                            <img src={staticShoeLayer3} alt="" id="layer-bottom-img" />
                            </picture>
                            <picture id="layer-base" style={{transform: 'translateY(0px)'}}>
                            <source srcSet={staticShoeLayer4} />
                            <img src={staticShoeLayer4} alt="" id="layer-insole-img" />
                            </picture>
                        </figure>
                        </div>
                    </div>
                    </div>
                </figure>
                </div>
            </div>
            </section>

            <style>
            {`
                .sec6 {
                    background:url(${bgSec6Mobile});
                }

                @media (min-width: 768px) {
                    .sec6 {
                    background-image: url(${bgSec6});
                    }
                }
                `}
            </style>

            <section className="bg-black py-3 px-3 p-md-4 p-lg-5 sec6-outer">
                <div className="container-fluid sec sec6 p-4 p-sm-5 p-lg-5 d-flex">
                    <div className="row flex-grow-1">
                    <article className="content col-9 col-sm-6 col-md-5 col-lg-4 col-xl-4 ml-auto align-self-start pt-4 mt-lg-5 ">
                        {sec6Text}
                    </article>
                    </div>
                </div>
            </section>

            <style>
            {`
                .sec7 {
                    background:url(${bgSec7Mobile});
                }

                @media (min-width: 480px) {
                    .sec7 {
                    background-image: url(${bgSec7});
                    }
                }
                `}
            </style>

            <section className="sec sec7 d-flex">
                <div className="container d-flex flex-grow-1">
                    <div className="row  flex-grow-1">
                    <article className="content col-9 col-sm-8 col-md-6 col-lg-6 col-xl-6 mr-auto align-self-center">
                        {sec7Text}
                    </article>
                    </div>
                </div>
            </section>

            <style>
            {`
                .sec8 {
                    background:url(${bgSec8Mobile});
                }

                @media (min-width: 568px) {
                    .sec8 {
                    background-image: url(${bgSec8});
                    }
                }
                `}
            </style>

            <section className="sec sec8 d-flex">
                <div className="container d-flex flex-grow-1">
                    <div className="row  flex-grow-1">
                    <article className="content col-12 col-sm-8 col-md-6 col-lg-6 col-xl-5 ml-auto align-self-start align-self-sm-center pl-xl-5">
                            {sec8Text}
                        <p className="mt-lg-5 pt-xl-4 d-flex mb-0 text-center">
                        <a href={sec8Button1Url} className="btn btn-outline-light mb-1 mr-2">{sec8Button1Text}</a> <a href={sec8Button2Url} className="btn btn-outline-light mb-1 ml-2">{sec8Button2Text}</a>
                        </p>       
                    </article>
                    </div>
                </div>
            </section>

            <style>
            {`
                .sec9 {
                    background:url(${bgSec9});
                }
            `}
            </style>


            <section className="sec sec9 d-flex">
                <div className="container d-flex flex-grow-1">
                <div className="row  flex-grow-1">
                    <article className="content col-11 col-sm-8 col-md-6 col-lg-6 col-xl-6 mr-auto align-self-center">
                        {sec9Text}
                    </article>
                    <figure className="figure col-12 col-sm-12 col-md-5 col-lg-6 col-xl-6 ml-auto align-self-center">
                    <img src={staticGrip} className="grip-img hide animated" alt="" />
                    </figure>
                </div>
                </div>
            </section> 


    </div>
    );
}
WoolCross1.defaultProps = {
    bannerText: <> 
                <h1>MERINO <br /> WOOL <br /> <strong>CROSS X</strong></h1>
    </>,
    bannerQualityText: <>100% <br />merino <br />wool</>,
    bannerImage: banner,
    bannerImageMobile: bannerMobile,
    bannerShoeLayer: banner_shoe,
    bannerPrice: '159€',
    bannerButton1Text: 'WOMEN',
    bannerButton2Text: 'MEN',
    bannerButton1Url: '#',
    bannerButton2Url: '#',

    bgSec3: staticBgSec3,
    bgSec3Mobile: staticBgSec3Mobile,
    sec3Text: <>
        <h2>Discover  <br /> the world's First <br />  <strong>MERINO sports shoe</strong></h2>
        <p>Made of Merino Wool 3D-Strech material  <br />
        and a 2-component sole for maximum cushioning.  <br />
        Developed for a new sport comfort experience!
        </p>
        <ul className="list-unstyled pt-4">
            <li className="mb-3">100 % Merino lining</li>
            <li className="mb-3">Interchangeable merino wool footbed</li>
            <li className="mb-3">Micro-Grip sole technology</li>
        </ul>
    </>,

    bgSec4: staticBgSec4,
    sec4Text: <>
                            <h2>The new Merino <br /> <strong>Sport Comfort</strong></h2>
                        <p>The performance sports shoe made of water-repellent material and an inner lining of 100% Merino Wool 3D stretch. So that you don't have to do without comfort during sport.
                        </p>
    </>,
    sec4Button1Text: 'WOMEN',
    sec4Button2Text: 'MEN',
    sec4Button1Url: '#',
    sec4Button2Url: '#',

    bgSec5: staticBgSec5,
    sec5Text:<>
                <h2><strong>Discover <br /> Merino wool </strong> <br /> layers of comfort</h2>
                    <ul className="list-unstyled">
                    <li className="mb-3">100% Merino Wool Knit</li>
                    <li className="mb-3">100% Merino Wool Stretch Lining</li>
                    <li className="mb-3">Extra Light Merino Wool Footbed</li>
                    <li className="mb-3">Durable and light EVA sole</li>
                    </ul>
    </>,
    shoeLayer1: staticShoeLayer1,
    shoeLayer2: staticShoeLayer2,
    shoeLayer3: staticShoeLayer3,
    shoeLayer4: staticShoeLayer4,

    bgSec6: staticBgSec6,
    bgSec6Mobile: staticBgSec6Mobile,
    sec6Text:<>
            <h2>Socks <strong>Adé!</strong></h2>
            <p>The Wool Cross X is lined with soft merino wool. Slip into the shoe barefoot - you won't want to take it off again. </p>

    </>,

    bgSec7: staticBgSec7,
    bgSec7Mobile: staticBgSec7Mobile,
    sec7Text:<>
        <h2>No, you don't  <br /> have to turn up <br /> <strong>your nose </strong></h2>
            <p>Merino wool neutralises unpleasant odours, absorbs foot moisture and transports it outwards more effectively than any synthetic material can.
        </p>         
    </>,
    
    bgSec8: staticBgSec8,
    bgSec8Mobile: staticBgSec8Mobile,
    sec8Text: <>
        <h2><strong>MERINO WOOL</strong> <br /> REGULATES THE <br />TEMPERATURE</h2>
        <p>This natural material is a real <br /> all-rounder. On cold days your feet are kept pleasantly warm - on warm <br /> days refreshingly cool. 
        </p> 
    </>,
    sec8Button1Text: 'WOMEN',
    sec8Button2Text: 'MEN',
    sec8Button1Url: '#',
    sec8Button2Url: '#',   

    sec9Text:<>
                        <h2>MAximum <strong>grip</strong></h2>
                    <p>The Micro-Grip sole technology is adapted to every type of surface - whether snow, slush or rough terrain. The special sole provides maximum stability and ideal cushioning.
                    </p> 
    </>,
    bgSec9: staticBgSec9,
    grip: staticGrip,

}

export default WoolCross1;